import styled from '@emotion/styled';
import React from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

const GlowingBorder = styled.div<{ isOnBuySide: boolean }>`
	position: absolute;
	width: 50%;
	height: 40px;
	transition: left 0.2s, border 0.2s;

	top: -1px;
	left: ${(props) => (props.isOnBuySide ? '0' : '50%')};
	border-width: 1px;
	border-color: ${(props) =>
		props.isOnBuySide ? 'var(--green-60)' : 'var(--red-50)'};
`;

const BuySellToggle = (props: {
	onChange: (newSide: 'buy' | 'sell') => void;
	isPerp: boolean;
}) => {
	const isOnBuySide = useDriftStore((s) => s.tradeForm.side === 'buy');

	const handleChange = (newSide: 'buy' | 'sell') => {
		props.onChange(newSide);
	};

	return (
		<div className="relative h-[40px] w-full inline-flex border border-container-border rounded-sm">
			<div
				className="flex items-center justify-center w-1/2 h-full text-positive-green hover:cursor-pointer hover:bg-container-bg-hover"
				onClick={() => handleChange('buy')}
			>
				<span>{props.isPerp ? 'Long' : 'Buy'}</span>
			</div>
			<div
				className="flex items-center justify-center w-1/2 h-full text-negative-red hover:cursor-pointer hover:bg-container-bg-hover"
				onClick={() => handleChange('sell')}
			>
				<span>{props.isPerp ? 'Short' : 'Sell'}</span>
			</div>
			<GlowingBorder className="rounded-sm" isOnBuySide={isOnBuySide} />
		</div>
	);
};

export default React.memo(BuySellToggle);
